import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      padding: theme.spacing(3),
      '&$notActive': {
        padding: theme.spacing(3),
        '& $title': {
          color: COLORS.gray.gray30,
        },
      },
    },
    notActive: {},
    titleRow: {
      display: 'flex',
    },
    title: {},
    optional: {
      color: COLORS.gray.gray40,
      fontWeight: theme.typography.fontWeightRegular,
    },
    resetButton: {
      marginBottom: 'auto',
      marginLeft: 'auto',
      fontWeight: theme.typography.fontWeightMedium,
    },
    tag: {
      display: 'inline-block',
      padding: theme.spacing(0.375, 0.75, 0.25),
      backgroundColor: COLORS.gray.gray80,
      color: COLORS.gray.gray30,
      textTransform: 'capitalize',
      borderRadius: theme.shape.borderRadiusMinimal,
      width: 'max-content',
    },
    subtitle: {
      color: COLORS.gray.gray40,
      lineHeight: theme.typography.pxToRem(16),
      marginTop: theme.spacing(1),
    },
    buttonsWrapper: {
      display: 'flex',
      justifyContent: 'end',
    },
    editButton: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
    },
  }),
  { name: 'DraftStepBlock' }
);
